import view from './view.js';

export {view};


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_car/index.js